export const handleCommonEvent = that => (target, value, func = function(){}) => {
    that.setState({
        [target]: value
    }, () => {func(value)} );    
    // func(value);
}

export const handleApplyDateRangePicker = that => (event, picker) => {
    const { t } = that.props;
    const { periods } = that.state;
    let foundSelectedPeriod = periods.find((element) => {
        return t('common:periods.' + element.SchedulePeriodName) === picker.chosenLabel
    })

    if (foundSelectedPeriod === undefined) {
        let label = picker.startDate.format("YYYY/MM/DD") + '-' + picker.endDate.format("YYYY/MM/DD")
        foundSelectedPeriod = {
            SchedulePeriodName: 'customRange',
            StartDate: picker.startDate.format("MM/DD/YYYY"),
            EndDate: picker.endDate.format("MM/DD/YYYY"),
            label: label,
            value: label
        }
    }

    that.setState({
        periodSelected: foundSelectedPeriod,
    })
}

// DualListBox
export const handleChangeDualBox = that => (selected, position) => {
    const listIncluded = [...that.state[selected.target].included]
    const listExcluded = [...that.state[selected.target].excluded]

    if (position === 'included') {
        for (var i = listExcluded.length; i--;) {
            if (listExcluded[i].value === selected.value) listExcluded.splice(i, 1);
        }
        listIncluded.push(selected)
    } else {
        for (var j = 0; j < listIncluded.length; j++) {
            if (listIncluded[j].value === selected.value) listIncluded.splice(j, 1);
        }
        listExcluded.push(selected)
    }

    that.setState(prevState => ({
        [selected.target]: {
            ...prevState[selected.target],
            included: listIncluded,
            excluded: listExcluded
        }
    }))
}

// DualListBox
export const moveAll = that => (target, direction) => {
    const listIncluded = [...that.state[target].included];
    const listExcluded = [...that.state[target].excluded];
    if(direction === 'toRight'){
        that.setState({
            [target]: {
                included: [],
                excluded: [...listExcluded, ...listIncluded]
            }
        })
    } else {
        that.setState({
            [target]: {
                included: [...listExcluded, ...listIncluded],
                excluded: []
            }
        })
    }
}

function createArray(object){
    let list = [];
    for (let item in object) {
        list.push(object[item])
    }
    return list
}

export const moveSelectedAll = that => (target, included, excluded) => {
    that.setState({
        [target]: {
            included: createArray(included),
            excluded: createArray(excluded)
        }
    })
}

export const updateIncluded = that => (target, included) => {
    that.setState(prevState => ({
        [target]: {
            ...prevState[target],
            included: createArray(included),
        }
      }))

} 